module.exports = __webpack_public_path__ + "img/m.ce425e3d.png";